export default {
	'.*CAREFREE_SHOPPING.*': 'Carefree_Shopping',
	'.*COMPETITIVE_ADVANTAGE.*': 'Competitive Advantage',
	'.*DRIVER_GEAR.*': 'Driver Gear',
	'.*MAINTENANCE_MENU.*': 'Maintenance Menu',
	'.*PARTS_LEAD.*': 'Parts Home',
	'.*SCHEDULE_SERVICE.*': 'Schedule Service',
	'.*SERVICE_CARE_MAINTENANCE.*': 'VW Care Maintenance',
	'.*SERVICE_CREDIT_CARD.*': 'Service Credit Card',
	'.*SERVICE_DEFAULT.*': 'Schedule Service',
	'.*SERVICE_EVENT.*': 'Service Event',
	'.*SERVICE_LEAD.*': 'Service Home',
	'.*SERVICE_XPRESS.*': 'Service Xpress',
	'.*SPECIALS_LISTING_PARTS.*': 'Dealer Coupons',
	'.*TIRE_STORE.*': 'Tire Store',
	'.*VW_AFTER_SALES.*': 'LandingPage_FBservice',
	'.*VWACCESSORIES.*': 'Accessories Home',
	'.*2020_SIGN_THEN_DRIVE_EVENT_1.*': '2020_STDNewEngland',
	'.*2020_SIGN_THEN_DRIVE_EVENT__1.*': '2020_STDNewEnglandHispanic',
	'.*2020_SIGN_THEN_DRIVE_EVENT_2.*': '2020_STDNewEnglandHispanic',
	'^VW_ATLAS$': 'LandingPage_Atlas-Dare-to-Compare',
	'^VW_TIGUAN$': 'LandingPage_MY18_All-New_Tiguan',
	'^VW_WARRANTY$': 'LandingPage_WarrantyDec17',
	'^SITEBUILDER_2019_JETTA_1$': 'LandingPage_MY19_Jetta',
	'^SITEBUILDER_2021ID4_1': 'ID4_ModelLandingPage',
	'^SITEBUILDER_VOLKSWAGEN_ID_4_ELECTRIC_VEHICLE_1': 'ID4_ModelLandingPage',
	CERTIFIED_PRE_OWNED_VEHICLES: 'LandingPage_CPO'
};
